import { useEffect, useState } from 'react';

/**
 * Tracks how much of the viewport is currently covered by the on-screen
 * keyboard, using window.visualViewport (window.innerHeight does not
 * change on iOS when the keyboard opens — only visualViewport.height does).
 * Returns 0 when no keyboard is open or visualViewport is unsupported.
 */
export function useVisualViewportKeyboardInset() {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!vv) return undefined;

    const update = () => {
      const covered = window.innerHeight - vv.height - vv.offsetTop;
      setInset(Math.max(0, Math.round(covered)));
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return inset;
}
